import client from './client'

export function login (credentials) {
  return client.post('/admin/auth/login', credentials).then(response => response.data)
}

export function logout () {
  return client.post('/admin/auth/logout')
}

export function getDashboard () {
  return client.get('/admin/dashboard').then(response => response.data)
}

export function getSmsSendingDashboard (params) {
  return client.get('/admin/sms-dashboard', { params }).then(response => response.data)
}

export function getSmsAlertRules () { return client.get('/admin/sms-alerts/rules').then(response => response.data) }
export function getSmsAlertEvents () { return client.get('/admin/sms-alerts/events').then(response => response.data) }
export function saveSmsAlertRule (rule) {
  return (rule.ruleId ? client.put(`/admin/sms-alerts/rules/${rule.ruleId}`, rule) : client.post('/admin/sms-alerts/rules', rule)).then(response => response.data)
}

export function getMessages (params) {
  return client.get('/admin/messages', { params }).then(response => response.data)
}

export function getLatestSmsByPhone (phone) {
  return client.get('/admin/sms-record-query', { params: { phone } }).then(response => response.data)
}

export function getPushOverview () {
  return client.get('/admin/push/overview').then(response => response.data)
}

export function getPushEndpoints (params) {
  return client.get('/admin/push/endpoints', { params }).then(response => response.data)
}

export function getPushTemplates () {
  return client.get('/admin/push/templates').then(response => response.data)
}

export function createPushTemplate (payload) { return client.post('/admin/push/templates', payload).then(r => r.data) }
export function updatePushTemplate (code, payload) { return client.put(`/admin/push/templates/${encodeURIComponent(code)}`, payload).then(r => r.data) }
export function disablePushTemplate (code, reason) { return client.post(`/admin/push/templates/${encodeURIComponent(code)}/disable`, { reason }).then(r => r.data) }
export function getPushTemplateVersions (code) { return client.get(`/admin/push/templates/${encodeURIComponent(code)}/versions`).then(r => r.data) }
export function rollbackPushTemplate (code, version, reason) { return client.post(`/admin/push/templates/${encodeURIComponent(code)}/versions/${version}/rollback`, { reason }).then(r => r.data) }
export function getPushActions (params) { return client.get('/admin/push/actions', { params }).then(r => r.data) }
export function createPushAction (payload) { return client.post('/admin/push/actions', payload).then(r => r.data) }
export function updatePushAction (id, payload) { return client.put(`/admin/push/actions/${encodeURIComponent(id)}`, payload).then(r => r.data) }

export function getPushBroadcasts () {
  return client.get('/admin/push/broadcasts').then(response => response.data)
}

export function getPushMessages () {
  return client.get('/admin/push/messages').then(response => response.data)
}

export function getMessageDetail (messageId) {
  return client.get(`/admin/messages/${encodeURIComponent(messageId)}`).then(response => response.data)
}

export function getProviders () {
  return client.get('/admin/providers').then(response => response.data)
}

export function getVoiceStrategies () {
  return client.get('/admin/voice-strategies').then(response => response.data)
}

export function getCallbackExceptions (params) {
  return client.get('/admin/callback-exceptions', { params }).then(response => response.data)
}

export function getAdminCapabilities () {
  return client.get('/admin/capabilities').then(response => response.data)
}

export function submitUatTestSend (payload) {
  return client.post('/admin/uat-test-sends', payload).then(response => response.data)
}

export function getOperationalStatus () {
  return client.get('/admin/operations/status').then(response => response.data)
}

export function runAlertDrill (type) {
  return client.post(`/admin/operations/alert-drills/${encodeURIComponent(type)}`, {
    confirmed: true
  }).then(response => response.data)
}

export function getSmsConfig (resource) {
  return client.get(`/admin/sms-config/${smsConfigResource(resource)}`).then(response => legacySmsView(response.data))
}

export function createSmsConfig (resource, payload) {
  return client.post(`/admin/sms-config/${smsConfigResource(resource)}`, payload).then(response => legacySmsView(response.data))
}

export function updateSmsConfig (resource, id, payload) {
  return client.put(`/admin/sms-config/${smsConfigResource(resource)}/${encodeURIComponent(id)}`, payload).then(response => legacySmsView(response.data))
}

export function smsConfigAction (resource, id, action) {
  return client.post(`/admin/sms-config/${smsConfigResource(resource)}/${encodeURIComponent(id)}/actions/${encodeURIComponent(action)}`).then(response => legacySmsView(response.data))
}

export function getSmsConfigOperations (targetType, targetId) {
  const types = { provider: 'channel', sender: 'senderId', template: 'smsTemplate', binding: 'templateChannel' }
  return client.get('/admin/sms-config/operation-logs', { params: { targetType: types[targetType] || targetType, targetId } }).then(response => response.data)
}

export function getSmsRouteV2Runtime () {
  return client.get('/admin/sms-config-v2/runtime').then(response => response.data)
}

export function getSmsRouteV2Templates () {
  return client.get('/admin/sms-config-v2/templates').then(response => response.data)
}

export function getSmsRouteV2 (templateId) {
  return client.get(`/admin/sms-config-v2/templates/${encodeURIComponent(templateId)}`).then(response => response.data)
}

export function saveSmsRouteV2 (templateId, payload) {
  return client.put(`/admin/sms-config-v2/templates/${encodeURIComponent(templateId)}`, payload).then(response => response.data)
}

export function smsRouteV2Action (templateId, action) {
  return client.post(`/admin/sms-config-v2/templates/${encodeURIComponent(templateId)}/actions/${encodeURIComponent(action)}`).then(response => response.data)
}

function smsConfigResource (resource) {
  return ({ providers: 'channels', senders: 'sender-ids', templates: 'sms-templates', bindings: 'template-channels' })[resource] || resource
}

function legacySmsView (value) {
  if (Array.isArray(value)) return value.map(legacySmsView)
  if (!value || typeof value !== 'object') return value
  const result = { ...value }
  const names = {
    channelId: 'providerId', channelIds: 'providerIds', channelCode: 'providerCode', channelName: 'providerName',
    senderIdRequired: 'senderRequired', senderIdConfigId: 'senderProfileId', senderIdCode: 'profileCode',
    senderIdValue: 'senderId', registrationStatus: 'providerStatus', smsTemplateId: 'templateId',
    templateChannelId: 'bindingId'
  }
  Object.keys(names).forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(result, key)) {
      result[names[key]] = result[key]
      delete result[key]
    }
  })
  return result
}
